<div class="stepper-wrapper">
    <div *ngFor="let step of steps; index as i" class="stepper-item" [ngClass]="{'current': i === currentStep, 'completed': i < currentStep}">
        <div class="step-counter"></div>
    </div>
  </div>